/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback } from "react";
import { useFormik } from "formik";

import { toast } from "react-toastify";
import Timeout from "await-timeout";
import * as Yup from "yup";
import styled from "styled-components";
import DatePicker from "react-datepicker";
import { X } from "lucide-react";
import moment from "moment";
import { UncontrolledTooltip } from "reactstrap";
import { InputNumberFormat } from "@react-input/number-format";
import { useAuth } from "../../../context/AuthContext";
import useFetcher from "../../../hooks/useFetcher";

import { handleErrors } from "../../../services/handleErrors";
import { ButtonSecondary, ButtonSecondaryV2, SpinnerButtonPrimary, TagFiltersButton, ToggleButtonOv } from "../../../ui/buttons";
import SelectV2 from "../../../components/SelectV2";
import { CustomLabel, ErrorFeedback } from "../../../ui/labels";
import { InputNumberFormatWrapperOV, InputTextAreaOVWithFilter, InputTextOV } from "../../../ui/inputs";
import { StylesDatePicker } from "../../../ui/stylesDatePicker";
import FileUploader, { validateFile } from "./FileUploader";
import { configDatePickerLenguage } from "../../../components/RelevosInfoGeneral/utils";
import {
  createOrdenDeVenta,
  fetchCategoriasOrdenDeVenta,
  fetchSubClientesOrdenDeVentaPaginados,
  fetchSucursalesOrdenDeVenta,
  getCotizacionBySubClienteId,
  updateOrdenDeVenta,
  fetchClientesOrdenDeVenta,
} from "../../../services/moduloOrdenDeVentaServices";
import AsyncSelectV2 from "../../../components/SelectV2/AsyncSelectV2";
import { formatPeriodo, isValidEmail, promiseOptions, removeLeadingZeros } from "../utils";
import { fetchCompanias } from "../../../services/companiaServices";
import { fetchServicios } from "../../../services/servicioServices";
import { uploadFiles } from "../../../services/fileServices";
import { BlurSpinner } from "../../../components/BlurSpinner";
import { getNotasDePedidoCategory } from "../../../services/notasDePedidoServices";
import { formatNumberWithCommas } from "../../../components/OrdenDeVentaForm/utils";
import modulos from "../../../mocks/modulos";

const ContainerRelative = styled.div`
  position: relative;
  z-index: 50;
`;

const GridGroup = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: ${({ gridTemplateColumns }) => gridTemplateColumns || "1fr 1fr"};
  grid-column-gap: 20px;
  grid-row-gap: 10px;
  margin: 5px 0;

  .w-100 {
    min-width: 0;
    box-sizing: border-box;
  }
`;

const SectionsButtons = styled.div`
  gap: 10px;
  width: 80%;
  display: flex;
  flex-direction: column;
  margin: 40px 0px 10px 0px;
`;

const SectionTitle = styled.h3`
  color: #293134;
  font-family: Nunito;
  font-size: 18px;
  font-style: normal;
  font-weight: 800;
  margin-bottom: 16px;
`;

const createOrOpdateOrdenDeVenta = async (orderData, id) => {
  if (!id) {
    return createOrdenDeVenta(orderData);
  }
  return updateOrdenDeVenta(id, orderData);
};
const FormNuevaOV = ({ toggle, reloadOrdenesDeVenta, setFullSize, ordenData }) => {
  const { currentUser } = useAuth();
  const isAudit = currentUser && currentUser.haveAuditAccess(modulos.ORDENES_DE_VENTA);

  const [readOnly, setReadOnly] = useState(false);
  const [step1, setStep1] = useState(false);
  const [step2, setStep2] = useState(false);
  const [step3, setStep3] = useState(false);
  const [companias, isLoadingCompanias] = useFetcher(fetchCompanias, undefined, "fetchCompanias");
  const [servicios, isLoadingServicios] = useFetcher(fetchServicios, undefined, "fetchServicios");
  const [sucursales, isLoadingSucursales] = useFetcher(fetchSucursalesOrdenDeVenta, undefined, "fetchSucursalesOrdenDeVenta");
  const [categories, isLoadingCategories] = useFetcher(getNotasDePedidoCategory, undefined, "getNotasDePedidoCategory");
  const [categoriesOV, isLoadingCategoriesOV] = useFetcher(fetchCategoriasOrdenDeVenta, undefined, "fetchCategoriasOrdenDeVenta");
  const subservicios = categoriesOV && categoriesOV.clienteSubservicio;

  const businessLineEnum = categories && categories.businessLine && categories.businessLine.type;

  const [subclienteId, setSubclienteId] = useState(null);
  const [cotizaciones, isLoadingCotizaciones] = useFetcher(getCotizacionBySubClienteId, [subclienteId]);

  const [subClientsParams, setSubClientsParams] = useState({ page: 1, perpage: 100 });
  const [currentClientIdToFilterSubclients, setCurrentClientIdToFilterSubclients] = useState();
  const [subclients, isLoadingSubclients] = useFetcher(fetchSubClientesOrdenDeVentaPaginados, [subClientsParams]);
  const [clientsParams, setClientsParams] = useState({ page: 1, perpage: 50 });
  const [clientesDefault, isLoadingClientes] = useFetcher(fetchClientesOrdenDeVenta, [clientsParams]);
  const [file, setFile] = useState(null);

  const locale = configDatePickerLenguage();
  const [periodoValue, setPeriodoValue] = useState(null); // ok OV
  const [emails, setEmails] = useState([]); // ok OV
  const [currentEmail, setCurrentEmail] = useState(null); // ok OV
  const [emailError, setEmailError] = useState(""); // ok OV

  const [totalValue, setTotalValue] = useState(null);
  const [clienteValue, setClienteValue] = useState(null); // ok OV
  const [subclienteValue, setSubclienteValue] = useState(null); // ok OV
  const [subservicioValue, setSubservicioValue] = useState(null); // ok OV
  const [subserviceLineValue, setSubserviceLineValue] = useState(null); // ok OV
  const canContinue = step1 || step2 || step3 || (!!clienteValue && !!subclienteValue); // ok OV
  const [responsableValue, setResponsableValue] = useState(null);

  // valores para mostrar cuando la OV es de Notas de Pedido
  const [subservicioText, setSubservicioText] = useState(null);

  const loadOptions = useCallback((inputValue) => {
    const inputWithoutCero = removeLeadingZeros(inputValue);
    return promiseOptions(
      inputWithoutCero,
      "query",
      fetchSubClientesOrdenDeVentaPaginados,
      (e) => {
        const legajo = e.numeroDeLegajo;
        const legajoFormateado = legajo && legajo.replace(/\.?0+$/, "").padStart(7, "0");
        return {
          label: `${legajoFormateado} - ${e.razonSocial}`,
          value: e.itemId,
          legajo: legajoFormateado,
          razonSocial: e.razonSocial,
          compania: e.compania,
          companiaCat: e.companiaCat,
          servicio: e.servicio2,
          sucursal: e.sucursal,
          businessLine: e.businessLine,
          clientId: e.ClientId,
        };
      },
      currentClientIdToFilterSubclients && { ClientId: currentClientIdToFilterSubclients }
    );
  });

  const loadClientesOptions = useCallback((inputValue, searchParam) => {
    if (searchParam) {
      return promiseOptions(inputValue, searchParam, fetchClientesOrdenDeVenta, (e) => {
        return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
      });
    }
    return promiseOptions(inputValue, "razonSocial", fetchClientesOrdenDeVenta, (e) => {
      return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
    });
  });

  const subserviciosOptions = subservicios
    ? subservicios
        .map((e) => {
          return {
            label: `${e.servicio}-${e.subservicio}`,
            value: `${e.servicio}-${e.subservicio}`,
            id: e.id,
            subServiceLine: e.subServiceLine,
            proyectCategory: e.proyectCategoryMsd,
            codigoServicio: e.codigoServicio,
          };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  const subClientesDefaultOptions =
    subclients && subclients.rows && subclients.rows.length > 0
      ? subclients.rows
          .map((e) => {
            const legajo = e.numeroDeLegajo;
            const legajoFormateado = legajo && legajo.replace(/\.?0+$/, "").padStart(7, "0");

            return {
              label: `${legajoFormateado} - ${e.razonSocial}`,
              value: e.itemId,
              legajo: legajoFormateado,
              razonSocial: e.razonSocial,
              compania: e.compania,
              companiaCat: e.companiaCat,
              servicio: e.servicio2,
              sucursal: e.sucursal,
              businessLine: e.businessLine,
              clientId: e.ClientId,
            };
          })
          .sort((a, b) => (a.label > b.label ? 1 : -1))
      : [];

  const clientesDefaultOptions = clientesDefault.rows
    ? clientesDefault.rows
        .map((e) => {
          return { label: e.razonSocial, value: e.razonSocial, cuit: e.cuit, id: e.id };
        })
        .sort((a, b) => (a.label > b.label ? 1 : -1))
    : [];

  function getFunctionToFilter(filter, selected) {
    if (filter === "subcliente") {
      if (selected === null) {
        setClienteValue(selected);
      }
      setSubclienteValue(selected);
    }

    if (filter === "cliente") {
      setClienteValue(selected);
      setSubclienteValue(null);
    }

    if (filter === "subservicio") {
      setSubservicioValue(selected);
    }
  }

  const handleDatesChange = (values) => {
    if (!values) {
      setPeriodoValue(null);
      return;
    }
    const fechaFormateada = moment(values).format("MM/YYYY");
    setPeriodoValue(fechaFormateada);
  };

  const handleReactSelectChange = (selected, options) => {
    const filtro = options.name;
    getFunctionToFilter(filtro, selected);
  };

  const handleAddEmail = (email) => {
    setEmails([...emails, email]);
  };

  const handleTryAddEmail = (email) => {
    if (!isValidEmail(email)) {
      setEmailError("El email no tiene un formato válido");
      return;
    }

    setEmailError("");
    handleAddEmail(email);
    setCurrentEmail("");
  };

  const handleRemoveEmail = (email) => {
    setEmails(emails.filter((e) => e !== email));
  };

  const inputError = () => {
    const error = { error: false };

    if (subservicioValue === null) {
      error.subservicio = "Debe seleccionar un subservicio.";
      error.error = true;
    } else if (subservicioValue.value === "" || subservicioValue.value === undefined) {
      error.subservicio = "Debe seleccionar un subservicio.";
      error.error = true;
    }

    if (totalValue === null) {
      error.total = "Este campo es obligatorio.";
      error.error = true;
    } else if (totalValue.value === "" || totalValue.value === undefined) {
      error.total = "Este campo es obligatorio.";
      error.error = true;
      // eslint-disable-next-line no-restricted-globals
    } else if (totalValue.number <= 0 || isNaN(totalValue.number)) {
      error.total = "El total debe ser mayor a 0.";
      error.error = true;
    }

    if (periodoValue === null) {
      error.periodo = "Debe seleccionar un periodo.";
      error.error = true;
    }

    if (!file || file.length === 0) {
      error.file = "Debe cargar un archivo para soporte";
      error.error = true;
    }

    return error;
  };

  const messageError = inputError();

  const formik = useFormik({
    initialValues: {
      cliente: "",
      subclienteId: null,
      empresa: null,
      businessLine: "",
      servicio: null,
      subservicio: null,
      sucursalId: null,
      nroCotizacion: "",
      responsable: currentUser && currentUser.user && currentUser.user.Pi && currentUser.user.Pi.itemId,
      total: null,
      nroOCAsociada: "",
      periodo: "",
      emailParaEnviarLaFactura: "",
      observacionesParaFacturador: "",
      fileId: null,

      projectCategory: "",
      subserviceLine: "",
      subcliente: "",
      cuit: "",
      servicioId: null,

      guidCliente: null,
      idOportunidad: "",

      subservicioId: "",

      estado: 1,
    },
    onSubmit: async (values) => {
      if (messageError.error) {
        return;
      }

      const [month, year] = periodoValue ? periodoValue.split("/").map(Number) : [0, 0];
      try {
        const ordenToPost = {
          ...values,
          cliente: clienteValue ? clienteValue.value : null,
          subclienteId: subclienteValue ? subclienteValue.value : null,
          servicio: values.servicioId && servicios ? servicios.find((c) => c.id === formik.values.servicioId).text : "test",
          subservicio: subservicioValue ? subservicioValue.value : null,
          total: totalValue ? totalValue.number : null,
          periodo: periodoValue ? new Date(year, month - 1) : null,
          emailParaEnviarLaFactura: emails ? emails.join(";") : "",

          projectCategory: subservicioValue && subservicioValue.proyectCategory ? subservicioValue.proyectCategory : null,
          subserviceLine: subservicioValue && subservicioValue.subServiceLine ? subservicioValue.subServiceLine : null,
          subcliente: subclienteValue && subclienteValue.legajo ? subclienteValue.legajo : null,
          cuit: clienteValue && clienteValue.cuit ? clienteValue.cuit : null,

          guidCliente: cotizaciones && cotizaciones.rows && cotizaciones.rows.length > 0 ? cotizaciones.rows[0].guidCliente : "",
          idOportunidad: cotizaciones && cotizaciones.rows && cotizaciones.rows.length > 0 ? cotizaciones.rows[0].idOportunidad : "",
        };

        const { message, result } = await createOrOpdateOrdenDeVenta(ordenToPost, (ordenData && ordenData.idOrdenDeVenta) || null);

        toast.success(message);
        await Timeout.set(1000);

        if (result && result.idOrdenDeVenta && file && file.length > 0) {
          try {
            const { result: fileResult } = await uploadFiles({ entity: "npOrdenDeVenta", entityId: result.idOrdenDeVenta, files: file });
            if (fileResult && fileResult.length > 0 && fileResult[0].id) {
              await updateOrdenDeVenta(result.idOrdenDeVenta, { fileId: fileResult[0].id });
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error(error);
            toast.error(`Error subiendo los archivos. Intente nuevamente despues de crear la orden de venta.`);
          }
        }
        reloadOrdenesDeVenta();
        toggle(true);
      } catch (error) {
        handleErrors(error, toast.error, null, formik);
      }
    },

    validationSchema: Yup.object().shape({
      empresa: Yup.string().required("Este campo es requerido."),
      businessLine: Yup.string().required("Este campo es requerido."),
      servicioId: Yup.number().typeError("Este campo es requerido.").required("Este campo es requerido."),
      sucursalId: Yup.number().typeError("Este campo es requerido.").required("Este campo es requerido."),
      responsable: Yup.string().required("Este campo es requerido."),
      observacionesParaFacturador: Yup.string().required("Este campo es requerido."),
      idOportunidad: Yup.string().required("Este campo es requerido."),
    }),
  });

  useEffect(() => {
    if (ordenData) {
      setResponsableValue(
        (ordenData && ordenData.piResponsable && ordenData.piResponsable.nombreApellido) || (ordenData && ordenData.piResponsable && ordenData.piResponsable.nombre)
      );
    } else if (currentUser && currentUser.user) {
      setResponsableValue(`${currentUser.user.nombre} ${currentUser.user.apellido}`);
    } else {
      setResponsableValue("Sin asignar");
    }
  }, [currentUser, ordenData]);

  useEffect(() => {
    if (clienteValue) {
      setSubClientsParams({ ...subClientsParams, ClientId: clienteValue.id });
      setCurrentClientIdToFilterSubclients(clienteValue.id);
      return;
    }
    setCurrentClientIdToFilterSubclients(null);
    setSubClientsParams({ ...subClientsParams });
  }, [clienteValue]);

  useEffect(async () => {
    if (subclienteValue) {
      if (subclienteValue.clientId) {
        setClientsParams({ ...clientsParams, id: subclienteValue.clientId });
        const cliente = await loadClientesOptions(subclienteValue.clientId, "id");
        const clienteData = cliente && cliente.length > 0 ? cliente[0] : null;
        setClienteValue(clienteData);
      } else {
        setClientsParams({ ...clientsParams, query: subclienteValue.razonSocial });
        const cliente = await loadClientesOptions(subclienteValue.razonSocial);
        const clienteData = cliente && cliente.length > 0 ? cliente[0] : null;
        setClienteValue(clienteData);
      }

      setSubclienteId(subclienteValue.value);
      formik.setFieldValue("empresa", subclienteValue.compania);
      formik.setFieldValue("businessLine", subclienteValue.businessLine || "");
      formik.setFieldValue("servicioId", subclienteValue.servicio);
      formik.setFieldValue("sucursalId", subclienteValue.sucursal);
      setClientsParams({ ...clientsParams });
    }
  }, [subclienteValue]);

  useEffect(() => {
    if (subservicioValue) {
      const subserviceLine = subservicioValue && subservicioValue.subServiceLine ? subservicioValue.subServiceLine : null;
      setSubserviceLineValue(subserviceLine);
      formik.setFieldValue("subservicioId", subservicioValue.id || null);
    }
  }, [subservicioValue]);

  const handleCancelarOrden = () => {
    toggle(!!ordenData);
  };

  useEffect(async () => {
    if (ordenData && !isLoadingCompanias && !isLoadingServicios && !isLoadingSucursales && !isLoadingSubclients) {
      if (ordenData.estado !== 1 || isAudit) {
        setReadOnly(true);
      } else {
        setReadOnly(false);
      }

      setStep1(true);
      const subClientes = await loadOptions(ordenData.cliente);
      setSubclienteValue(subClientes.find((option) => option.value === ordenData.subclienteId));
      setSubservicioValue(subserviciosOptions.find((option) => option.value === ordenData.subservicio) || null);
      setTotalValue(ordenData.total ? { number: ordenData.total, value: formatNumberWithCommas(ordenData.total) } : null);
      formik.setFieldValue("nroOCAsociada", ordenData.nroOCAsociada);
      formik.setFieldValue("observacionesParaFacturador", ordenData.observacionesParaFacturador);
      formik.setFieldValue("emailParaEnviarLaFactura", ordenData.emailParaEnviarLaFactura);
      setEmails(ordenData.emailParaEnviarLaFactura.split(","));

      if (ordenData.notaDePedidoId && categories) {
        const subserviceLineEnum = categories && categories.estadoNP && categories.estadoNP.subserviceLine;
        const subserviceLine = subserviceLineEnum && subserviceLineEnum[ordenData.subserviceLine - 1];

        setSubserviceLineValue(subserviceLine.text || "");
        setSubservicioText(ordenData.servicio);
        formik.setFieldValue("nroCotizacion", ordenData.nroCotizacion);
        formik.setFieldValue("idOportunidad", ordenData.idOportunidad);

        setSubclienteValue({
          businessLine: ordenData.businessLine,
          compania: ordenData.empresa,
          label: `${ordenData.subcliente}-${ordenData.cliente}`,
          legajo: ordenData.subcliente,
          razonSocial: ordenData.cliente,
          servicio: 1,
          sucursal: ordenData.sucursalId,
          value: ordenData.subclienteId,
        });
      }

      if (ordenData.periodo) {
        const formatted = formatPeriodo(ordenData.periodo);
        setPeriodoValue(formatted);
      }
    }
  }, [ordenData, isLoadingCompanias, isLoadingServicios, isLoadingSucursales, isLoadingSubclients, isLoadingCotizaciones, categories, currentUser]);

  const handleContinuar = async () => {
    if (step1) {
      const errors = await formik.validateForm();
      const requiredFields = ["empresa", "businessLine", "servicioId", "subservicio", "sucursalId", "responsable", "idOportunidad"];
      const hasStep1Errors = requiredFields.some((field) => errors[field]);
      if (hasStep1Errors) {
        formik.setTouched(requiredFields.reduce((acc, field) => ({ ...acc, [field]: true }), {}));
        return;
      }
      if (messageError && messageError.subservicio) {
        formik.setTouched({ subservicio: true });
        return;
      }
      setStep1(false);
      setStep2(true);
    } else if (step2) {
      const requiredFields = ["total", "emailParaEnviarLaFactura", "periodo"];
      const hasStep2Errors = requiredFields.some((field) => messageError[field]);
      if (hasStep2Errors) {
        if (emails.length === 0) {
          setEmailError("Se requiere al menos un email");
        }

        formik.setTouched(requiredFields.reduce((acc, field) => ({ ...acc, [field]: true }), {}));
        return;
      }
      if (emails.length === 0) {
        setEmailError("Se requiere al menos un email");
        return;
      }
      if (messageError && messageError.periodo) {
        formik.setTouched({ periodo: true });
        return;
      }
      setStep2(false);
      setStep3(true);
    } else if (step3) {
      if (messageError && messageError.file) {
        formik.setTouched({ fileId: true });
      }

      formik.submitForm();
    } else {
      setStep1(true);
    }
  };

  useEffect(() => {
    if (step1 || step2 || step3) {
      setFullSize(true);
    }
  }, [step1, step2, step3]);

  // setear idOportunidad cuando se obtiene la cotizacion
  useEffect(() => {
    if (cotizaciones && cotizaciones.rows) {
      const oportinidadId = cotizaciones && cotizaciones.rows && cotizaciones.rows[0] && cotizaciones.rows[0].idOportunidad ? cotizaciones.rows[0].idOportunidad : null;
      if (!oportinidadId) {
        toast.error("La cotización no tiene oportunidad asociada");
      } else {
        formik.setFieldValue("idOportunidad", oportinidadId);
      }
    }
  }, [cotizaciones]);

  return (
    <form className="w-100 p-3 pt-0" onSubmit={formik.handleSubmit}>
      <BlurSpinner
        isLoading={
          isLoadingCompanias ||
          isLoadingServicios ||
          isLoadingSucursales ||
          isLoadingCotizaciones ||
          isLoadingCategories ||
          isLoadingCategoriesOV ||
          isLoadingSubclients ||
          isLoadingClientes ||
          (ordenData && !subclienteValue) ||
          (ordenData && !clienteValue)
        }
      >
        <ContainerRelative className="row">
          <GridGroup gridTemplateColumns={step1 || step2 || step3 ? "2fr 1fr" : "1fr"}>
            <GridGroup>
              {/* razon social cliente */}
              <div className="w-100">
                <CustomLabel htmlFor="motivo" className="w-100" fontSize="18px" fontWeight="800" disabled={step1 || step2 || step3 || readOnly}>
                  Razón social cliente*
                </CustomLabel>
                <AsyncSelectV2
                  className="w-100"
                  height="40px"
                  id="cliente"
                  name="cliente"
                  onChange={handleReactSelectChange}
                  value={clienteValue || null}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoadingClientes}
                  isDisabled={isLoadingClientes || step1 || step2 || step3 || readOnly}
                  defaultOptions={clientesDefaultOptions}
                  loadOptions={loadClientesOptions}
                />
                {formik.errors.motivo && formik.touched.motivo && <ErrorFeedback>{formik.errors.motivo}</ErrorFeedback>}
              </div>

              {/* subcliente */}
              <div className="w-100">
                <CustomLabel htmlFor="motivo" className="w-100" fontSize="18px" fontWeight="800" disabled={step1 || step2 || step3 || readOnly}>
                  Subcliente*
                </CustomLabel>
                <AsyncSelectV2
                  className="w-100"
                  height="40px"
                  id="subcliente"
                  name="subcliente"
                  onChange={handleReactSelectChange}
                  value={subclienteValue || null}
                  placeholder="Seleccionar..."
                  isClearable
                  isLoading={isLoadingSubclients}
                  isDisabled={isLoadingSubclients || step1 || step2 || step3 || readOnly}
                  defaultOptions={subClientesDefaultOptions}
                  loadOptions={loadOptions}
                />

                {formik.errors.motivo && formik.touched.motivo && <ErrorFeedback>{formik.errors.motivo}</ErrorFeedback>}
              </div>
            </GridGroup>
          </GridGroup>
          {(step1 || step2 || step3) && (
            <GridGroup gridTemplateColumns="1fr 2fr">
              <SectionsButtons>
                <ToggleButtonOv
                  type="button"
                  isSelected={step1}
                  onClick={() => {
                    setStep1(true);
                    setStep2(false);
                    setStep3(false);
                  }}
                >
                  Datos Generales
                </ToggleButtonOv>
                <ToggleButtonOv
                  type="button"
                  isSelected={step2}
                  onClick={() => {
                    setStep2(true);
                    setStep3(false);
                    setStep1(false);
                  }}
                >
                  Datos de facturacion
                </ToggleButtonOv>
                <ToggleButtonOv
                  type="button"
                  isSelected={step3}
                  onClick={() => {
                    setStep3(true);
                    setStep2(false);
                    setStep1(false);
                  }}
                >
                  Observaciones
                </ToggleButtonOv>
              </SectionsButtons>
              <div>
                {step1 && (
                  <div className="mt-3 mb-0 d-flex flex-column">
                    <SectionTitle>Datos Generales</SectionTitle>
                    <GridGroup gridTemplateColumns="48% 48%">
                      {/* razon social adecco */}
                      <div>
                        <CustomLabel htmlFor="empresa" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Razón social Adecco*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="empresa"
                          name="empresa"
                          value={formik.values.empresa && companias ? companias.find((c) => c.id === formik.values.empresa).text : "sin empresa"}
                          className={`w-100 ${formik.errors.empresa && formik.touched.empresa ? "error-field" : ""}`}
                        />
                        {formik.errors.motivo && formik.touched.empresa && <ErrorFeedback>{formik.errors.empresa}</ErrorFeedback>}
                      </div>

                      {/* business line */}
                      <div>
                        <CustomLabel htmlFor="businessLine" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Business Line*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="businessLine"
                          name="businessLine"
                          placeholder="Business Line"
                          value={
                            formik.values.businessLine && Array.isArray(businessLineEnum)
                              ? (businessLineEnum.find((c) => c.id === formik.values.businessLine) || {}).text || ""
                              : ""
                          }
                          className={`w-100 ${formik.errors.businessLine && formik.touched.businessLine ? "error-field" : ""}`}
                        />
                        {formik.errors.businessLine && formik.touched.businessLine && <ErrorFeedback>{formik.errors.businessLine}</ErrorFeedback>}
                      </div>

                      {/* servicio */}
                      <div>
                        <CustomLabel htmlFor="servicioId" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Servicio*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="servicioId"
                          name="servicioId"
                          value={
                            formik.values.servicioId && Array.isArray(servicios)
                              ? (servicios.find((c) => c.id === formik.values.servicioId) || {}).text || "sin servicio"
                              : ""
                          }
                          className={`w-100 ${formik.errors.servicioId && formik.touched.servicioId ? "error-field" : ""}`}
                        />
                        {formik.errors.servicio && formik.touched.servicio && <ErrorFeedback>{formik.errors.servicio}</ErrorFeedback>}
                      </div>

                      {/* subservicio */}
                      <div>
                        <CustomLabel htmlFor="subservicio" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                          Subservicio*
                        </CustomLabel>
                        {ordenData && ordenData.notaDePedidoId ? (
                          <InputTextOV
                            disabled
                            height="40px"
                            id="subservicio"
                            name="subservicio"
                            value={subservicioText || "sin subservicio"}
                            className={`w-100 ${formik.errors.subservicio && formik.touched.subservicio ? "error-field" : ""}`}
                          />
                        ) : (
                          <SelectV2
                            height="40px"
                            className="w-100"
                            id="subservicio"
                            name="subservicio"
                            error={messageError.error && messageError.subservicio && formik.touched.subservicio}
                            onChange={handleReactSelectChange}
                            value={subservicioValue || null}
                            placeholder="Seleccionar..."
                            isClearable
                            isDisabled={formik.isSubmitting || readOnly}
                            options={subserviciosOptions.filter((option) => {
                              if (!formik.values.servicioId || !option || !option.codigoServicio) return option;
                              return option.codigoServicio === JSON.stringify(formik.values.servicioId);
                            })}
                          />
                        )}
                        {messageError.error && messageError.subservicio && formik.touched.subservicio && <ErrorFeedback>{messageError.subservicio}</ErrorFeedback>}
                      </div>

                      {/* serviceLine */}
                      <div>
                        <CustomLabel htmlFor="subserviceLine" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Subservice Line*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="subserviceLine"
                          name="subserviceLine"
                          value={subserviceLineValue || ""}
                          className={`w-100 ${formik.errors.subserviceLine && formik.touched.subserviceLine ? "error-field" : ""}`}
                        />
                        {formik.errors.subserviceLine && formik.touched.subserviceLine && <ErrorFeedback>{formik.errors.subserviceLine}</ErrorFeedback>}
                      </div>

                      {/* sucursal */}
                      <div>
                        <CustomLabel htmlFor="sucursal" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Sucursal*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="sucursal"
                          name="sucursal"
                          value={formik.values.sucursalId && sucursales ? sucursales.find((c) => c.itemId === formik.values.sucursalId).titulo : "sin sucursal"}
                          className={`w-100 ${formik.errors.sucursalId && formik.touched.sucursalId ? "error-field" : ""}`}
                        />
                        {formik.errors.sucursalId && formik.touched.sucursalId && <ErrorFeedback>{formik.errors.sucursalId}</ErrorFeedback>}
                      </div>

                      {/* numero de cotizacion */}
                      <div>
                        <CustomLabel htmlFor="nroCotizacion" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Número de cotización
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="nroCotizacion"
                          name="nroCotizacion"
                          value={
                            ordenData && ordenData.notaDePedidoId
                              ? formik.values.nroCotizacion || "sin cotizacion"
                              : (cotizaciones && cotizaciones.rows && cotizaciones.rows.length > 0 && cotizaciones.rows[0].idCotizacion) || "sin cotizacion"
                          }
                          className={`w-100 ${formik.errors.nroCotizacion && formik.touched.nroCotizacion ? "error-field" : ""}`}
                        />
                        {formik.errors.nroCotizacion && formik.touched.nroCotizacion && <ErrorFeedback>{formik.errors.nroCotizacion}</ErrorFeedback>}
                      </div>

                      {/* id de oportunidad */}
                      <div>
                        <CustomLabel htmlFor="idOportunidad" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Id de Oportunidad*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="idOportunidad"
                          name="idOportunidad"
                          value={
                            ordenData && ordenData.notaDePedidoId
                              ? formik.values.idOportunidad || "sin oportunidad"
                              : (cotizaciones && cotizaciones.rows && cotizaciones.rows.length > 0 && cotizaciones.rows[0].idOportunidad) || "sin oportunidad"
                          }
                          className={`w-100 ${formik.errors.idOportunidad && formik.touched.idOportunidad ? "error-field" : ""}`}
                        />
                        {formik.errors.idOportunidad && formik.touched.idOportunidad && <ErrorFeedback>{formik.errors.idOportunidad}</ErrorFeedback>}
                      </div>

                      {/* responsable */}
                      <div>
                        <CustomLabel htmlFor="responsable" className="w-100" fontSize="18px" fontWeight="800" disabled>
                          Responsable*
                        </CustomLabel>
                        <InputTextOV
                          disabled
                          height="40px"
                          id="responsable"
                          name="responsable"
                          className={`w-100 ${formik.errors.responsable && formik.touched.responsable ? "error-field" : ""}`}
                          value={responsableValue || "Sin asignar"}
                        />
                        {formik.errors.responsable && formik.touched.responsable && <ErrorFeedback>{formik.errors.responsable}</ErrorFeedback>}
                      </div>
                    </GridGroup>
                  </div>
                )}
                {step2 && (
                  <div className=" mt-3 mb-0 d-flex flex-column">
                    <SectionTitle>Datos de facturación</SectionTitle>
                    <GridGroup>
                      {/* total a facturar */}
                      {!readOnly && <UncontrolledTooltip target="total-label">No incluir costo IIBB, DYC, IF.</UncontrolledTooltip>}
                      <div id="total-label">
                        <CustomLabel htmlFor="total" id="total-label" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                          Total a Facturar*
                        </CustomLabel>
                        <InputNumberFormatWrapperOV>
                          <InputNumberFormat
                            // locales="en"
                            locales={["ban", "id"]}
                            id="precioDelServicio"
                            onNumberFormat={(event) => {
                              setTotalValue(event && event.detail && event.detail);
                            }}
                            onChange={() => {}}
                            disabled={formik.onSubmit || readOnly}
                            onBlur={formik.handleBlur}
                            value={(totalValue && totalValue.value) || ""}
                            thousandSeparator="."
                            decimalSeparator=","
                            style={messageError.total && formik.touched.total ? { border: "1px solid red", placeholder: "red" } : null}
                            maxLength={18}
                          />
                        </InputNumberFormatWrapperOV>
                        {messageError && messageError.total && formik.touched.total && <ErrorFeedback>{messageError.total}</ErrorFeedback>}
                      </div>

                      {/* Nro OC asociada */}
                      <div>
                        <CustomLabel htmlFor="nroOCAsociada" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                          Nro OC asociada
                        </CustomLabel>
                        <InputTextOV
                          disabled={readOnly}
                          height="40px"
                          id="nroOCAsociada"
                          name="nroOCAsociada"
                          value={formik.values.nroOCAsociada}
                          onChange={formik.handleChange}
                          className={`w-100 ${formik.errors.nroOCAsociada && formik.touched.nroOCAsociada ? "error-field" : ""}`}
                          autoComplete="off"
                        />
                        {formik.errors.nroOCAsociada && formik.touched.nroOCAsociada && <ErrorFeedback>{formik.errors.nroOCAsociada}</ErrorFeedback>}
                      </div>

                      {/* periodo */}
                      <div>
                        <StylesDatePicker
                          className="mb-1"
                          border={!(messageError.error && messageError.periodo && formik.touched.periodo)}
                          errorColor={messageError.error && messageError.periodo && formik.touched.periodo}
                        >
                          <CustomLabel htmlFor="periodo" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                            Periodo*
                          </CustomLabel>
                          <DatePicker
                            disabled={readOnly}
                            isClearable={!readOnly}
                            id="periodo"
                            name="periodo"
                            locale={locale}
                            showIcon
                            className="date-input digits w-100"
                            dateFormat="MM/yyyy"
                            placeholderText="MM/AAAA"
                            icon="fa fa-calendar"
                            onChange={handleDatesChange}
                            showMonthYearPicker
                            clearButtonClassName="clear-button"
                            value={periodoValue || null}
                            selected={periodoValue ? new Date(periodoValue).setDate(new Date(periodoValue).getDate() + 1) : null}
                            autoComplete="off"
                          />
                        </StylesDatePicker>
                        {messageError.error && messageError.periodo && formik.touched.periodo && <ErrorFeedback>{messageError.periodo}</ErrorFeedback>}
                      </div>
                    </GridGroup>
                    <GridGroup>
                      <div>
                        <CustomLabel htmlFor="email" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                          Emails para enviar la Factura*
                        </CustomLabel>
                        <InputTextOV
                          disabled={readOnly}
                          type="email"
                          height="40px"
                          id="email"
                          name="email"
                          value={currentEmail}
                          onChange={(e) => {
                            setCurrentEmail(e.target.value);
                            if (emailError) setEmailError("");
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              handleTryAddEmail(currentEmail);
                            }
                          }}
                          className={`w-100 ${emailError || (formik.errors.emailParaEnviarLaFactura && formik.touched.emailParaEnviarLaFactura) ? "error-field" : ""}`}
                        />
                        {emailError && <ErrorFeedback style={{ height: "0px" }}>{emailError}</ErrorFeedback>}
                      </div>

                      <div className="d-flex align-items-end">
                        <ButtonSecondary type="button" fontWeight="700" onClick={() => handleTryAddEmail(currentEmail)} disabled={readOnly}>
                          Agregar
                        </ButtonSecondary>
                      </div>
                    </GridGroup>

                    <div className="d-flex flex-wrap mt-3">
                      {emails.map((email) => (
                        <TagFiltersButton
                          className="mb-1"
                          type="button"
                          key={email}
                          onClick={(e) => {
                            e.stopPropagation();
                            navigator.clipboard.writeText(email.toString());
                            toast.success("Email copiado al portapapeles");
                          }}
                          disabled={readOnly}
                        >
                          {email}
                          <X
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveEmail(email);
                            }}
                            size={12}
                            className="ml-2"
                          />
                        </TagFiltersButton>
                      ))}
                    </div>
                  </div>
                )}
                {step3 && (
                  <div className=" mt-3 mb-0 d-flex flex-column">
                    <SectionTitle>Datos de facturación</SectionTitle>
                    <div>
                      <CustomLabel htmlFor="observacionesParaFacturador" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                        Observaciones para el facturador*
                      </CustomLabel>
                      <InputTextAreaOVWithFilter
                        filterNewlines
                        disabled={readOnly}
                        id="observacionesParaFacturador"
                        name="observacionesParaFacturador"
                        value={formik.values.observacionesParaFacturador}
                        onChange={formik.handleChange}
                        error={formik.errors.observacionesParaFacturador && formik.touched.observacionesParaFacturador}
                        maxLength={50}
                      />
                      {formik.errors.observacionesParaFacturador && formik.touched.observacionesParaFacturador && (
                        <ErrorFeedback>{formik.errors.observacionesParaFacturador}</ErrorFeedback>
                      )}
                    </div>

                    <div>
                      <CustomLabel htmlFor="fileId" className="w-100" fontSize="18px" fontWeight="800" disabled={readOnly}>
                        Soporte cliente*
                      </CustomLabel>
                      <FileUploader
                        disabled={readOnly}
                        onFilesChange={(files) => {
                          if (!files.length) return;
                          setFile(files);
                        }}
                        fileValidatorFn={validateFile}
                        onError={(error) => {
                          toast.error(error);
                        }}
                        prefilledFile={ordenData && ordenData.fileRespaldoCliente ? [ordenData.fileRespaldoCliente] : file}
                        name="fileId"
                        id="fileId"
                      />
                      {messageError.error && messageError.file && formik.touched.fileId && <ErrorFeedback>{messageError.file}</ErrorFeedback>}
                    </div>
                  </div>
                )}
              </div>
            </GridGroup>
          )}
        </ContainerRelative>
      </BlurSpinner>
      <div className="mt-3 mb-0 d-flex justify-content-end">
        <ButtonSecondaryV2 type="button" fontWeight="700" onClick={() => handleCancelarOrden()}>
          Cancelar
        </ButtonSecondaryV2>
        <SpinnerButtonPrimary
          isLoading={formik.isSubmitting}
          disabled={formik.isSubmitting || !canContinue || (step3 && readOnly)}
          type="button"
          onClick={handleContinuar}
        >
          {(() => {
            if (step3) {
              return ordenData ? "Guardar" : "Crear";
            }
            return "Continuar";
          })()}
        </SpinnerButtonPrimary>
      </div>
    </form>
  );
};

export default FormNuevaOV;
